<template>
  <!-- 案件詳細 -->
  <div id="CpapRequestDetail" v-if="data && data.patient">
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside" v-if="showRequestInfo">
        <!--<span style="font-size:20px;">申込み情報</span>-->
        <table>
          <tr><th>申込日時</th><td>
            <span>{{data.applicationDate}} {{data.applicationTime}}</span><span style="margin-left:10px;">{{data.applicationUserName}}</span>
          </td></tr>
          <tr v-if="innerUser && !isRequest">
            <th>出荷日</th><td>{{data.shippedDate}}</td>
          </tr>
          <tr v-if="data.completionDate">
            <th>完了日時</th><td><span>{{data.completionDate}} {{data.completionTime}}</span>
          </td></tr>
          <tr><th>受付番号</th><td>{{data.receiptNumber}}</td></tr>
          <tr>
            <th>見積番号</th>
            <td>{{data.estimateCode}}</td>
          </tr>
          <template v-for="(items,detailIndex) in data.estimateDetailCode">
            <tr :key="detailIndex" v-if="!isViewer">
              <th style="width:15%;"><span v-if="detailIndex==0">見積明細番号</span></th>
              <td style="width:80%;">
                <span style="display:inline-block;width:25%;">{{items.quotationDetailsNumber}}</span>
                <span style="display:inline-block;width:25%;padding-left:1%;">{{items.itemCode}}</span>
                <span style="display:inline-block;width:38%;padding-left:1%;">{{items.itemName}}</span>
              </td>
            </tr>
            <tr :key="detailIndex" v-else>
              <th style="width:20%;vertical-align:top;"><span v-if="detailIndex==0">見積明細番号</span></th>
              <td style="width:80%;">
                <span style="display:inline-block;width:40%;">{{items.quotationDetailsNumber}}</span>
                <span style="display:inline-block;width:40%;">{{items.itemCode}}</span>
                <br><span style="display:inline-block;width:100%;">{{items.itemName}}</span>
              </td>
            </tr>
          </template>
          <!-- 案件詳細 処方中止の場合 -->
          <template v-if="isOutPutProgress(progress,'処方中止')||isOutPutKind(kind,'処方中止')">
            <template v-if="cancelEdit">
              <!-- <tr v-if="!isHospital || !isDealer" > -->
              <tr v-if="innerUser">
                <!--社内ユーザーのみ表示-->
                <th>契約終了日<span class="require"/></th>
                <td><input type="date" v-model="data.contractEndDate" :min="data.contractEndMin" style="width:150px;" class="1" name="契約終了日" validate="required|date" /></td>
              </tr>
			        <tr v-if="innerUser">
                <!--社内ユーザーのみ表示-->
                <th>当月請求<span class="require"/></th>
                <td>
                  <select id="billingCurrentMonth" class="1" name="当月請求" validate="required" v-model="data.billingCurrentMonth">
                    <option v-for="billed in billedCurrentMonth" :value="billed.value" :key="billed.value">{{ billed.text }}</option>
                  </select>
                </td>
              </tr>
              <!-- <tr v-if="!isHospital && !isDealer"> -->
              <tr v-if="innerUser">
                <th>中止理由<span class="require"/></th>
                <td>
                  <select v-model="data.cancelReasonCode" class="1" name="中止理由" validate="required">
                    <option></option>
                    <option v-for="cancelCode in cancelCodeMaster" :value="cancelCode.value" :key="cancelCode.value">{{ cancelCode.text }}</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th style="vertical-align:top;">中止理由コメント</th>
                <td>
                  <textarea maxlength="256" style="resize:vertical;max-width:100%;height:60px;" v-model="data.cancelReasonText"></textarea>
                </td>
              </tr>
              <tr v-if="!isHospital && !isDealer" >
                <!--社内ユーザーのみ表示-->
                <th>回収先<span class="require"/></th>
                <td>
                  <div class="block">
                    <b-radio class="td_radio" name="回収先" v-model="data.collectionDestination" :native-value="0">支店回収</b-radio>
                    <b-radio class="td_radio" name="回収先" v-model="data.collectionDestination" :native-value="1">川越回収</b-radio>
                  </div>
                </td>
              </tr>
              <tr>
                <th>機器回収先<span class="require"/></th>
                <td>
                  <div class="block">
                    <b-radio class="td_radio" name="機器回収先" v-model="data.returnSource" :native-value="0">患者宅</b-radio>
                    <b-radio class="td_radio" name="機器回収先" v-model="data.returnSource" :native-value="1">医療機関</b-radio>
                  </div>
                </td>
              </tr>
              <tr><th>【機器回収先住所】</th></tr>
              <template v-if="data.returnSource == 1">
              <tr>
                <th>郵便番号<span class="require"/></th>
                <td>
                  <input
                    style="width: 270px;"
                    v-model="data.zip"
                    class="1"
                    :class="{'border-red': invalidPostcode}"
                    name="郵便番号"
                    validate="required|numeric"
                    maxlength="7"
                    :placeholder="postcodePlaceholder"
                  />
                  <b-button style="margin-left: 10px; width: 150px; height: 27px;" v-on:click="addressSearch(data.zip)">郵便番号検索</b-button>
                  <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <tr><th>住所<span class="require"/></th><td><input type="text" v-model="data.address" class="1" name="住所" validate="required" maxlength="280"/></td></tr>
              <tr><th>住所（丁目、番地）<span class="require"/></th><td><input type="text" v-model="data.address1" class="1" name="住所（丁目、番地）" validate="required" maxlength="256"/></td></tr>
              <tr><th>住所（建物名、号室）</th><td><input type="text" v-model="data.address2" maxlength="256"/></td></tr>
              <tr><th>回収先名称<span class="require"/><br>(患者名もしくは医療機関名)</th><td><input type="text" v-model="data.receiverName" maxlength="100" class="1" name="回収先名称" validate="required"/></td></tr>
              <tr>
                <th>連絡先(電話番号)<span class="require"/></th>
                <td>
                  <input
                    type="text"
                    v-model="data.phoneNumber"
                    maxlength="11"
                    class="1"
                    :class="{'border-red': invalidPhoneNumber}"
                    name="連絡先(電話番号)"
                    validate="required|numeric"
                    :placeholder="phonePlaceholder"
                  />
                  <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              </template>
              <template v-else>
                <tr>
                <th>郵便番号<span class="require"/></th>
                <td>
                  <input
                    style="width: 270px;"
                    v-model="data.deliveryPostcode"
                    class="1"
                    :class="{'border-red': invalidPatientPostcode}"
                    name="郵便番号"
                    validate="required|numeric"
                    maxlength="7"
                    :placeholder="postcodePlaceholder"
                  />
                  <b-button style="margin-left: 10px; width: 150px; height: 27px;" v-on:click="addressSearch(data.deliveryPostcode)">郵便番号検索</b-button>
                  <!-- <div v-show="invalidPatientPostcode" class="text-red">{{ invalidNumberMessage }}</div> -->
                  <div v-if="data.existingFlag && (isHospital || isDealer)" v-show="invalidPatientPostcode" class="text-red"></div>
                  <div v-else v-show="invalidPatientPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <tr><th>住所<span class="require"/></th><td><input type="text" v-model="data.deliveryAddress" class="1" name="住所" validate="required" maxlength="280"/></td></tr>
              <tr><th>住所（丁目、番地）<span class="require"/></th><td><input type="text" v-model="data.deliveryHouseNumber" class="1" name="住所（丁目、番地）" validate="required" maxlength="256"/></td></tr>
              <tr><th>住所（建物名、号室）</th><td><input type="text" v-model="data.deliveryBuilding" maxlength="256"/></td></tr>
              <tr><th>回収先名称<span class="require"/><br>(患者名もしくは医療機関名)</th><td><input type="text" v-model="data.deliveryDestination" maxlength="100" class="1" name="回収先名称" validate="required"/></td></tr>
              <tr v-if="data.deliveryPhoneNumber">
                <th>連絡先(電話番号)<span class="require"/></th>
                <td>
                  <input
                    type="text"
                    v-model="data.deliveryPhoneNumber"
                    maxlength="11"
                    class="1"
                    :class="{'border-red': invalidPatientMobilePhoneNumber}"
                    name="連絡先(電話番号)"
                    validate="required|numeric"
                    :placeholder="phonePlaceholder"
                  />
                  <!-- <div v-show="invalidPatientMobilePhoneNumber" class="text-red">{{ invalidNumberMessage }}</div> -->
                  <div v-if="data.existingFlag && (isHospital || isDealer)" v-show="invalidPatientMobilePhoneNumber" class="text-red"></div>
                  <div v-else v-show="invalidPatientMobilePhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <!-- <tr v-else>
              <th>連絡先(電話番号)<span class="require"/></th>
                <td>
                  <input
                    type="text"
                    v-model="data.patient.phoneNumber"
                    maxlength="11"
                    class="1"
                    :class="{'border-red': invalidPatientPhoneNumber}"
                    name="連絡先(電話番号)"
                    validate="required|numeric"
                    :placeholder="phonePlaceholder"
                  />
                  <div v-show="invalidPatientPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr> -->
              </template>
            </template>
            <template v-else>
              <tr v-if="innerUser">
                <!--社内ユーザーのみ表示-->
                <th>契約終了日</th>
                <td>{{convertDate(data.contractEndDate)}}</td>
              </tr>
              <tr v-if="innerUser">
                <!--社内ユーザーのみ表示-->
                <th>当月請求</th>
                <td>{{data.billingCurrentMonth | valueToTextFilter(billedCurrentMonth)}}</td>
              </tr>
              <tr>
                <th>中止理由</th>
                <td>{{data.cancelReasonCode | valueToTextFilter(cancelCodeMaster)}}</td>
              </tr>
              <tr>
                <th style="vertical-align:top;">中止理由コメント</th>
                <td>{{data.cancelReasonText}}</td>
              </tr>
              <tr v-if="!isHospital && !isDealer" >
                <!--社内ユーザーのみ表示-->
                <th>回収先</th>
                <td>
                  <span v-if="data.collectionDestination==0">支店回収</span>
                  <span v-if="data.collectionDestination==1">川越回収</span>
                </td>
              </tr>
              <tr>
                <th>機器回収先</th>
                <td>
                  <span v-if="data.returnSource==0">患者宅</span>
                  <span v-if="data.returnSource==1">医療機関</span>
                </td>
              </tr>
              <tr><th>【機器回収先住所】</th></tr>
              <template v-if="data.returnSource == 1">
              <tr>
                <th>郵便番号</th>
                <td>{{data.zip}}</td>
              </tr>
              <tr>
                <th>住所</th>
                <td>{{data.address}}</td>
                </tr>
              <tr>
                <th>住所（丁目、番地）</th>
                <td>{{data.address1}}</td>
              </tr>
              <tr>
                <th>住所（建物名、号室）</th>
                <td>{{data.address2}}</td>
              </tr>
              <tr>
                <th>回収先名称<br>(患者名もしくは医療機関名)</th>
                <td>{{data.receiverName}}</td>
              </tr>
              <tr>
                <th>連絡先(電話番号)</th>
                <td>{{data.phoneNumber}}</td>
                </tr>
              </template>
              <template v-else>
              <tr>
                <th>郵便番号</th>
                <td>{{data.deliveryPostcode}}</td>
              </tr>
              <tr>
                <th>住所</th>
                <td>{{data.deliveryAddress}}</td>
                </tr>
              <tr>
                <th>住所（丁目、番地）</th>
                <td>{{data.deliveryHouseNumber}}</td>
              </tr>
              <tr>
                <th>住所（建物名、号室）</th>
                <td>{{data.deliveryBuilding}}</td>
              </tr>
              <tr>
                <th>回収先名称<br>(患者名もしくは医療機関名)</th>
                <td>{{data.deliveryDestination}}</td>
              </tr>
              <tr v-if="data.deliveryPhoneNumber">
                <th>連絡先(電話番号)</th>
                <td>{{data.deliveryPhoneNumber}}</td>
              </tr>
              <!-- <tr v-else>
                <th>連絡先(電話番号)</th>
                <td>{{data.patient.phoneNumber}}</td>
              </tr> -->
              </template>
            </template>
          </template>
          <!-- 案件詳細 転院の場合 -->
          <template v-else-if="isOutPutProgress(progress,'転院')||isOutPutKind(kind,'転院申込み')">
            <tr>
              <th>転院予定月</th>
              <td>{{convertMonth(data.transferDate)}}</td>
            </tr>
            <tr><th>転院先</th><td>
              <span v-if="data.transferDestinationName">{{data.transferDestinationName}}</span>
              <span v-else-if="!data.transferDestinationName && (data.transferDestinationNameFree || data.transferDestinationAddress)">指定</span>
              <span v-else>未定</span></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">申送り事項</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.transferMemo}}</td>
            </tr>
            <!-- <template v-if="cancelEdit"> -->
            <tr v-if="innerUser && data.status==1 && patientDetailsFlag!=false">
              <th>当月請求<span class="require"/></th>
                <td>
                  <select id="billingCurrentMonth" class="1" name="当月請求" validate="required" v-model="data.billingCurrentMonth">
                    <option v-for="billed in billedCurrentMonth" :value="billed.value" :key="billed.value">{{ billed.text }}</option>
                  </select>
                </td>
            </tr>
            <tr v-else-if="innerUser && data.status==12 || data.status==14"><!--受付済み-->
              <th>当月請求</th>
                <td>
                  <span> {{data.billingCurrentMonth | valueToTextFilter(billedCurrentMonth)}}</span>
                </td>
            </tr>
            <tr v-else><!-- 仮受付 -->
              <th>当月請求</th>
                <td>
                  <!-- 当月請求欄は残し、内容は空白とする -->
                </td>
            </tr>
            <!-- </template> -->
          </template>
          <!-- 案件詳細 転入予定の場合 -->
          <template v-else-if="progress=='5'">
            <tr>
              <th>転院予定月</th>
              <td>{{convertMonth(data.transferDate)}}</td>
            </tr>
            <tr><th>転院先</th><td>
              <span v-if="data.transferDestinationName">{{data.transferDestinationName}}</span>
              <span v-else-if="!data.transferDestinationName && (data.transferDestinationNameFree || data.transferDestinationAddress)">指定</span>
              <span v-else>未定</span></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">申送り事項</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.transferMemo}}</td>
            </tr>
            <tr v-if="innerUser">
              <!-- <th>当月請求<span class="require"/></th> -->
              <th>当月請求</th>
              <td v-if="data.status==14 && patientDetailsFlag==false">
                <span> {{data.billingCurrentMonth | valueToTextFilter(billedCurrentMonth)}}</span>
              </td>
            </tr>
          </template>
          <tr><th>申込み状況</th>
            <td>
            <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
              {{getCpapProgres(data.status,data.kind)}}
            </span>
            </td>
          </tr>
          <tr v-if="innerUser">
            <th>状態</th>
            <td>
            <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
              {{getCpapStatus(data.status)}}
            </span>
            </td>
          </tr>
          <tr v-if="data.status==15">
            <th style="vertical-align:top;">理由</th>
            <td>
              <textarea maxlength="256" style="resize:vertical;max-width:100%;height:120px" disabled v-model="data.cancelMemo"></textarea>
            </td>
          </tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && resume && data.beforeItems && data.beforeItems.length > 0">
        <span style="font-size:20px;">転院前使用品目</span>
        <table>
          <tr>
            <th style="width:20%;">品目コード</th>
            <th style="width:30%;">品目名</th>
            <!-- <th style="width:25%;">見積詳細番号</th> -->
          </tr>
          <template v-for="(beforeItem,beforeItemIndex) in data.beforeItems">
            <tr :key="beforeItemIndex">
              <td>
                <span v-if="beforeItem.itemCode">{{beforeItem.itemCode}}</span>
                <span v-else style="color:red;">指示書未選択</span>
              </td>
              <td>{{beforeItem.itemName}}</td>
              <!-- <td>
                <span v-if="beforeItem.quotationDetailsNumber">{{beforeItem.quotationDetailsNumber}}</span>
                <span v-else style="color:red;">見積未選択</span>
              </td> -->
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && directionsItemList && directionsItemList.length > 0">
        <span style="font-size:20px;">品目情報</span>
        <table>
          <tr>
            <th style="width:20%;">品目コード</th>
            <th style="width:50%;">品目名</th>
            <!-- <th style="width:30%;">見積詳細番号</th> -->
          </tr>
          <template v-for="(directionsItem,directionsItemIndex) in directionsItemList">
            <tr :key="directionsItemIndex">
              <td style="width:20%;">
                <span v-if="directionsItem.itemCode">{{directionsItem.itemCode}}</span>
                <span v-else style="color:red;">指示書未選択</span>
              </td>
              <td style="width:50%;">{{directionsItem.name}}</td>
              <!-- <td style="width:30%;">
                <span v-if="directionsItem.quotationDetailsNumber">選択済み</span>
                <span v-else style="color:red;">見積未選択</span>
              </td> -->
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">基本情報</span>
        <table>
          <tr><th>指示日</th><td id="editMark"><span v-if="changedCheck('instructionDate',data.instructionDate)" class="change"></span></td><td>{{convertDate(data.instructionDate)}}</td></tr>
          <!-- <template v-if="data.depositUseFlag"> -->
          <!-- 外部ユーザーでは非表示20240329 -->
          <template v-if="data.depositUseFlag && innerUser">
            <tr>
              <th>契約終了日</th><td id="editMark"><span v-if="changedCheck('depositContractEndDate',data.depositContractEndDate)" class="change"></span></td>
              <td>{{convertDate(data.depositContractEndDate)}}</td>
            </tr>
            <tr>
              <th>当月請求</th><td id="editMark"><span v-if="changedCheck('depositBillingCurrentMonth',data.depositBillingCurrentMonth)" class="change"></span></td>
              <td>{{data.depositBillingCurrentMonth | valueToTextFilter(billedCurrentMonth)}}</td>
            </tr>
            <tr>
              <th>契約取消理由</th><td id="editMark"><span v-if="changedCheck('depositCancelReasonCode',data.depositCancelReasonCode)" class="change"></span></td>
              <td>{{data.depositCancelReasonCode | valueToTextFilter(cancelCodeMaster)}}</td>
            </tr>
          </template>
          <tr><th>申請元医療機関名</th><td id="editMark"><span v-if="changedCheck('medicalInstitutionName',data.medicalInstitutionName)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.medicalInstitutionName}}</td></tr>
          <tr><th>医師名</th><td id="editMark"><span v-if="changedCheck('doctorName',data.doctorName)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.doctorName}}</td></tr>
          <tr><th>事務担当者名</th><td id="editMark"><span v-if="changedCheck('clerkName',data.clerkName)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.clerkName}}</td></tr>
          <tr v-if="innerUser && commentFlg"><th>コメント</th><td></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.note}}</td></tr>
          <template v-if="data.isDealer">
            <tr><th>医療機関メールアドレス</th><td id="editMark"><span v-if="changedCheck('mailNotification',data.mailNotification)" class="change"></span></td><td><b-checkbox style="width: 26px" value="true" disabled v-model="data.mailNotification"></b-checkbox>申込み内容を医療機関にメールで通知する。</td></tr>
            <tr v-if="data.mailNotification"><th></th><td>{{data.hospitalMail}}</td></tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">患者情報</span>
        <table>
          <tr v-if="data.patientCode"><th>患者コード</th><td id="editMark"><span v-if="changedCheck('patientCode',data.patientCode)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientCode}}</td></tr>
          <tr><th>診察券ID（患者ID）</th><td id="editMark"><span v-if="changedCheck('patientRegistrationCard',data.patient.patientRegistrationCard)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.patientRegistrationCard}}</td></tr>
          <tr><th>患者名</th><td id="editMark"><span v-if="changedCheck('patientFamilyName',data.patient.patientFamilyName) || changedCheck('patientFirstName',data.patient.patientFirstName) " class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.patientFamilyName}} {{data.patient.patientFirstName}}</td></tr>
          <tr><th>患者名（カナ）</th><td id="editMark"><span v-if="changedCheck('patientFamilyNameKana',data.patient.patientFamilyNameKana) || changedCheck('patientFirstNameKana',data.patient.patientFirstNameKana)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.patientFamilyNameKana}} {{data.patient.patientFirstNameKana}}</td></tr>
          <tr><th>性別</th><td id="editMark"><span v-if="changedCheck('gender',data.patient.gender)" class="change"></span></td><td>{{data.patient.gender}}</td></tr>
          <tr><th>生年月日</th><td id="editMark"><span v-if="changedCheck('birthday',data.patient.birthday)" class="change"></span></td><td>{{convertDate(data.patient.birthday)}}<span v-if="data.patient.birthday" style="margin-left:10px;">{{data.patient.japaneseCalendar}}</span></td></tr>
          <tr><th>年齢</th><td id="editMark"><span v-if="changedCheck('age',data.patient.age)" class="change"></span></td><td>{{data.patient.age}}</td></tr>
          <tr><th>郵便番号</th><td id="editMark"><span v-if="changedCheck('zip',data.patient.zip)" class="change"></span></td><td>{{data.patient.zip}}</td></tr>
          <tr><th>住所</th><td id="editMark"><span v-if="changedCheck('address',data.patient.address)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.address}}</td></tr>
          <tr><th>住所（丁目、番地）</th><td id="editMark"><span v-if="changedCheck('address1',data.patient.address1)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.address1}}</td></tr>
          <tr><th>住所（建物名、号室）</th><td id="editMark"><span v-if="changedCheck('address2',data.patient.address2)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.address2}}</td></tr>
          <tr v-if="!isInstrument"><th>納品先宛名</th><td id="editMark"><span v-if="changedCheck('receiverName',data.patient.receiverName)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.receiverName}}</td></tr>
          <tr><th>連絡先（携帯電話）</th><td id="editMark"><span v-if="changedCheck('mobilePhone',data.patient.mobilePhone)" class="change"></span></td><td>{{data.patient.mobilePhone}}</td></tr>
          <tr><th>連絡（自宅・その他）</th><td id="editMark"><span v-if="changedCheck('phoneNumber',data.patient.phoneNumber)" class="change"></span></td><td>{{data.patient.phoneNumber}}</td></tr>
          <tr><th>フォローアップコール</th><td id="editMark"><span v-if="changedCheck('followUpCall',data.patient.followUpCall)" class="change"></span></td><td><span v-if="data.patient.followUpCall">する</span><span v-else>しない</span></td>
          <tr><th>病名</th><td id="editMark"><span v-if="changedCheck('disease',data.patient.disease)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.disease}}</td></tr>
          <tr><th>感染症</th><td id="editMark"><span v-if="changedCheck('infection',data.patient.infection)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.infection | infectionFilter()}}</td></tr>
          <tr><th>感染症名(その他)</th><td id="editMark"><span v-if="changedCheck('infectionName',data.patient.infectionName)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.infectionName}}</td></tr>
          <tr><th>地域医療連携施設名</th><td id="editMark"><span v-if="changedCheck('communityMedicineName',data.patient.hospitalName)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.hospitalName}}</td></tr>
          <tr><th>地域医療連携施設　医師名</th><td id="editMark"><span v-if="changedCheck('communityMedicineDoctorName',data.patient.doctorName)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.doctorName}}</td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">装置情報</span>
        <table>
          <tr><th>機種</th><td id="editMark"><span v-if="changedCheck('model',data.model)" class="change"></span></td><td>{{data.model | getNameFilter(models)}}</td></tr>
          <tr><th>シリアル</th><td id="editMark"><span v-if="changedCheck('serial',data.serial)" class="change"></span></td><td>{{data.serial}}</td></tr>
          <!-- <tr><th>使用機器</th><td><b-checkbox class="cstmCheckBox" v-model="data.depositUseFlag" disabled>預託機を使用する（要預託契約）</b-checkbox></td></tr> -->
          <!-- 処方変更の場合 設定変更対応欄不要20231225-->
          <!-- <tr v-if="data.kind == cpapKindMap.applicationChange"><th>設定変更対応</th>
            <td id="editMark"><span v-if="changedCheck('settingChanger',data.settingChanger)" class="change"></span></td>
            <td v-if="data.settingChanger==0">医療機関にて対応済</td>
            <td v-if="data.settingChanger==1">Philipsへ対応依頼</td>
          </tr> -->
        </table>
      </div>
      <!-- 印刷用フッター -->
      <div class="printTarget print_footer" style="display:none;">
        （診察券ID）{{data.patient.patientRegistrationCard}}／（患者名）{{data.patient.patientFamilyName}} {{data.patient.patientFirstName}}
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">設定情報</span>
        <div style="display: flex;">
          <table class="settings">
            <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===0})">
              <tr v-if="content.type==='char' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck()" class="change"></span></td>
                <td>{{content.value}}{{content.unit}}</td>
              </tr>
              <tr v-if="content.type==='sel' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck()" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}{{content.unit}}</td>
              </tr>
              <tr v-if="content.type==='calender' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck()" class="change"></span></td>
                <td>{{content.value | getCalenderValueFilter()}}</td>
              </tr>
              <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck()" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}</td>
              </tr>
            </template>
          </table>
        </div>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">加温加湿器</span>
        <div style="display: flex;">
          <table class="settings">
            <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===1})">
              <tr v-if="content.type==='char' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('moistarea')" class="change"></span></td>
                <td>{{content.value}}{{content.unit}}</td>
              </tr>
              <tr v-if="content.type=== 'sel' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('moistarea')" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}{{content.unit}}</td>
              </tr>
              <tr v-if="content.type=== 'calender' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('moistarea')" class="change"></span></td>
                <td>{{content.value | getCalenderValueFilter()}}</td>
              </tr>
              <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('moistarea')" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}</td>
              </tr>
            </template>
            <tr v-if="data.useMoist"><th>品目コード</th><td id="editMark"><span v-if="changedCheck('moistItemCode',data.moistItemCode) || hardwareCheck() || addCheck('moistarea')" class="change"></span></td><td>{{data.moistItemCode}}</td></tr>
            <tr v-if="data.useMoist"><th>シリアル</th><td id="editMark"><span  v-if="changedCheck('moistSerial',data.moistSerial) || hardwareCheck() || addCheck('moistarea')" class="change"></span></td><td>{{data.moistSerial}}</td></tr>
          </table>
        </div>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">通信モジュール</span>
        <div style="display: flex;">
          <table class="settings">
            <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===2})">
              <tr v-if="content.type==='char' && data.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('modulearea') || modulchangedCheck()" class="change"></span></td>
                <td>{{content.value}}{{content.unit}}</td>
              </tr>
              <tr v-if="content.type=== 'sel' && data.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('modulearea') || modulchangedCheck()" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}{{content.unit}}</td>
              </tr>
              <tr v-if="content.type=== 'calender' && data.useModule && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('modulearea') || modulchangedCheck()" class="change"></span></td>
                <td>{{content.value | getCalenderValueFilter()}}</td>
              </tr>
              <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('modulearea') || modulchangedCheck()" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}</td>
              </tr>
            </template>
            <tr v-if="data.useModule"><th>品目コード</th><td id="editMark"><span v-if="changedCheck('moduleItemCode',data.moduleItemCode) || hardwareCheck() || addCheck('modulearea') || modulchangedCheck()" class="change"></span></td><td>{{data.moduleItemCode}}</td></tr>
            <!-- <tr v-if="data.useModule"><th>シリアル</th><td id="editMark"><span v-if="changedCheck('moduleSerial',data.moduleSerial) || hardwareCheck() || addCheck('modulearea') || modulchangedCheck()" class="change "></span></td><td>{{data.moduleSerial}}</td></tr> -->
            <tr v-if="data.useModule && this.data.reportFormatType != 3"><th>シリアル</th><td id="editMark"><span v-if="changedCheck('moduleSerial',data.moduleSerial) || hardwareCheck() || addCheck('modulearea') || modulchangedCheck()" class="change "></span></td><td>{{data.moduleSerial}}</td></tr>
          </table>
        </div>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">マスク</span>
        <div style="display: flex;">
          <table class="settings">
            <tr>
              <th style="white-space:pre-wrap;width:250px;">マスク：種類</th>
              <td id="editMark"><span v-if="changedCheck('maskType',data.maskType)" class="change"></span></td><td>
              <td>{{data.maskType}}</td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;width:250px;">マスク：クッションサイズ</th>
              <td id="editMark"><span v-if="changedCheck('cushionSize',data.cushionSize)" class="change"></span></td><td>
              <td>{{data.cushionSize}}</td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;width:250px;">マスク：フレームサイズ</th>
              <td id="editMark"><span v-if="changedCheck('frameSize',data.frameSize)" class="change"></span></td><td>
              <td>{{data.frameSize}}</td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;width:250px;">マスク：固定方法</th>
              <td id="editMark"><span v-if="changedCheck('fixingMethod',data.fixingMethod)" class="change"></span></td><td>
              <td>{{data.fixingMethod}}</td>
            </tr>
            <tr v-if="innerUser">
              <th style="white-space:pre-wrap;width:250px;">ロット番号</th>
              <td id="editMark"><span v-if="changedCheck('lot',data.lot)" class="change"></span></td><td>
              <td>{{data.lot}}</td>
            </tr>
            <tr v-if="data.maskType=='その他'">
              <th style="white-space:pre-wrap;width:250px;">備考</th>
              <td id="editMark"><span v-if="changedCheck('memo',data.memo)" class="change"></span></td><td>
              <td>オーダー情報の備考欄を参照してください。</td>
            </tr>
          </table>
        </div>
      </div>
      <!-- 印刷用フッター -->
      <div class="printTarget print_footer" style="display:none;">
        （診察券ID）{{data.patient.patientRegistrationCard}}／（患者名）{{data.patient.patientFamilyName}} {{data.patient.patientFirstName}}
      </div>
      <div class="card-content margin-top printMargin printBreakInside pageBreakBefore" v-if="!isDeliveryInfoHidden&&!isOutPutProgress(progress,'処方中止')&&!isOutPutKind(kind,'処方中止')&&!resume">
        <span style="font-size:20px;">納品先情報</span>
        <table>
          <template v-if="data.delivaryTarget=='hospital'">
            <!-- 医療機関発送の場合 -->
            <tr><th>機器納品先</th><td>医療機関</td></tr>
            <tr><th>郵便番号</th><td>{{data.zip}}</td></tr>
            <tr><th>住所</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address}}</td></tr>
            <tr><th>住所（丁目、番地）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address1}}</td></tr>
            <tr><th>住所（建物名、号室）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address2}}</td></tr>
            <tr><th>納品先宛名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receiverName}}</td></tr>
            <tr><th>連絡先(電話番号)</th><td>{{data.phoneNumber}}</td></tr>
          </template>
          <tr v-if="data.delivaryTarget=='home'"><th>機器納品先</th><td>患者宅</td></tr>
          <template v-if="innerUser">
            <tr>
              <th style="vertical-align:top;">納品書コメント1</th>
              <td>{{data.deliveryStatementComment1}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">納品書コメント2</th>
              <td>{{data.deliveryStatementComment2}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">発送元</th>
              <td>{{data.senderType | codeToValueFilter(cpapSenderMaster)}}</td>
            </tr>
            <tr v-if="isSendBranch()">
              <th style="vertical-align:top;">発送方法</th>
              <td>{{data.shippingMethod | codeToValueFilter(cpapShippingMethodList)}}</td>
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && isRequest && isSendBranch()">
        <span style="font-size:20px;">配達情報</span>
        <table>
          <tr style="text-align:top;">
            <th style="vertical-align:top;">出荷日</th>
            <td>{{convertDate(data.shippingDate)}}</td>
          </tr>
        </table>
      </div>
      <!-- 
          <tr>
            <th>配達指定日の有無</th>
            <td><span v-if="data.isAppointedDelivery=='0'">配達指定日なし</span><span v-if="data.isAppointedDelivery=='1'">配達指定日あり</span></td>
          </tr>
          <tr v-if="data.isAppointedDelivery=='1'">
            <th style="vertical-align:top;">配達指定日</th>
            <td>{{convertDate(data.appointedDeliveryDate)}}</td>
          </tr>
          <tr v-if="data.isAppointedDelivery=='1'">
            <th style="vertical-align:top;">配達時間帯</th>
            <td>{{data.appointedDeliveryPeriodOfTime | valueToTextFilter(deliveryTimeZone)}}</td>
          </tr>
          <tr>
            <th style="vertical-align:top;">指定納期</th>
            <td>{{convertDate(data.specifiedDeliveryDate)}}</td>
          </tr>
      -->
      <!-- 社内ユーザーかつ、処方変更(返却あり)の場合 -->
      <div class="card-content margin-top" v-if="innerUser && data.kind==cpapKindMap.applicationChange && data.machineReturn">
        <span style="font-size:20px;">返却情報</span>
        <table>
          <tr>
            <th>回収先</th>
            <td>
              <span v-if="data.collectionDestination==0">支店回収</span>
              <span v-if="data.collectionDestination==1">川越回収</span>
            </td>
          </tr>
          <tr>
            <th>契約終了日</th>
            <td>{{convertDate(data.contractEndDate)}}</td>
          </tr>
          <tr>
            <th>当月請求</th>
            <td>{{data.billingCurrentMonth | valueToTextFilter(billedCurrentMonth)}}</td>
          </tr>
          <tr>
            <th>中止理由</th>
            <td>{{data.cancelReasonCode | valueToTextFilter(cancelCodeMaster)}}</td>
          </tr>
          <tr>
            <th style="vertical-align:top;">中止理由コメント</th>
            <td>{{data.cancelReasonText}}</td>
          </tr>
        </table>
      </div>

      <div class="card-content margin-top" v-if="showRequestMemo">
        <span style="font-size:20px;">オーダー情報</span>
        <table>
          <template v-if="innerUser && !isRequest">
            <tr>
              <th style="vertical-align:top;">請求開始日</th>
              <td id="editMark"><span v-if="changedCheck('billingStartDate',data.billingStartDate)" class="change"></span></td><td>
              <td>{{convertDate(data.billingStartDate)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">請求書コメント</th>
              <td id="editMark"><span v-if="changedCheck('billComment',data.billComment)" class="change"></span></td><td>
              <td>{{data.billComment}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">診療科コード</th>
              <td id="editMark"><span v-if="changedCheck('departmentCode',data.departmentCode)" class="change"></span></td><td>
              <td>{{data.departmentCode | valueToTextFilter(departmentMaster)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">得意先区分</th>
              <td id="editMark"><span v-if="changedCheck('customerClass',data.customerClass)" class="change"></span></td><td>
              <td>{{data.customerClass | valueToTextFilter(customerCategory)}}</td>
            </tr>
            <tr v-if="innerUser && resume">
              <th style="vertical-align:top;">前回消耗品供給日</th>
              <td><span></span></td><td>
              <td>{{convertDate(data.accessoryLastSupplyDate)}}</td>
            </tr>            
            <tr v-if="data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval">
              <th style="vertical-align:top;">直送先種別</th>
              <td id="editMark"><span v-if="changedCheck('directShippingType',data.directShippingType)" class="change"></span></td><td>
              <td>{{data.directShippingType | codeToValueFilter(cpapDirectShippingList)}}</td>
            </tr>
            <tr v-if="data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval">
              <th style="vertical-align:top;">リースアップ種別</th>
              <td id="editMark"><span v-if="changedCheck('leaseUpType',data.leaseUpType)" class="change"></span></td><td>
              <td>{{data.leaseUpType | codeToValueFilter(cpapLeaseUpList)}}</td>
            </tr>
            <!-- webシステムより不要との回答あり
            <tr>
              <th style="vertical-align:top;">戦略施策</th>
              <td>{{data.strategicMeasures | valueToTextFilter(strategicMeasures)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">戦略施策コメント</th>
              <td>{{data.strategicMeasuresComment}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">予備</th>
              <td>{{data.reserve | valueToTextFilter(reserve)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">予備コメント</th>
              <td>{{data.reserveComment}}</td>
            </tr> -->
          </template>
          <tr>
            <th style="vertical-align:top;">備考</th>
            <td id="editMark"><span v-if="changedCheck('memo',data.memo)" class="change"></span></td><td>
            <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.memo}}</td>
          </tr>
        </table>
      </div>
      <!-- 印刷用フッター -->
      <div class="printTarget print_footer" style="display:none;">
        （診察券ID）{{data.patient.patientRegistrationCard}}／（患者名）{{data.patient.patientFamilyName}} {{data.patient.patientFirstName}}
      </div>
    </div>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" title="医療機関選択" labelForOrg="医療機関名" @select="setHospital" :exclusionId="data.belongsId" :agreedInfoDisclosure="isHospital || isDealer"></organizationSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {
  role,
  extUserStatus,
  cpapShippingMethodList,
  cpapSenderMaster,
  cpapKindMap,
  cpapDirectShippingList,
  cpapLeaseUpList,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder
} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";

export default {
  name: "CpapRequestDetail",
  props: {
    data:null,
    showRequestInfo:{default:false},
    showRequestMemo:{default:true},
    innerUser:{},
    progress:"",
    patientDetailsFlag:{},
    kind:"",
    isEdit:null,
    isMasterAcquisition:true,
    cancelEdit:{default:false},
    deliveryHidden:{default:false},
    requestFlg:{default:false},
    directionsItem:{default:() => ([])},
    isResume:{default:false},
    viewerFlg:{default:false},
    commentFlg:{default:false},
  },
  methods: {
    isHideItem: function(displayName) {
      if(displayName == "登録方法"){
        var patientManagement = this.data.prescriptionItems.find(val => val.displayName == "患者情報管理")
        if(patientManagement && patientManagement.value=='0'){
          return true
        }
      }
      if(displayName == "E-mailアドレス"){
        var mobileApply = this.data.prescriptionItems.find(val => val.displayName == "モバイルアプリ")
        if(mobileApply && mobileApply.value=='0'){
          return true
        }
      }
      return false
    },
    // getDepositoryCodeMaster: function() {
    //   this.depositoryCodeMaster = []
    //   if(!this.officeCode) return
    //   // Web Api Call
    //   var _this = this;
    //   this.apiCall(
    //     function(client){
    //       return client.apis.apiCommon.getCpapStorageLocationPOST({
    //         body:{
    //           salesOfficeCode: "J"+_this.officeCode
    //         }
    //       });
    //     },
    //     async function(result){
    //       _this.depositoryCodeMaster = result.obj;
    //     },
    //     function(result){
    //       _this.showErrorMessage(result);
    //     }
    //   );
    // },
    isSendBranch: function() {
      if(!this.data.senderType) return false
      var target = this.cpapSenderMaster.find(val => val.code == this.data.senderType)
      if(target && target.name.indexOf("支店") != -1){
        // 支店発送の場合
        return true
      }
      return false
    },
    convertDate: function(day){
      return day ? day.replace(/-/g, "/") : ""
    },
    convertMonth: function(month){
      if(!month) return ""
      var y = month.split("-")[0];
      var m = month.split("-")[1];
      return y + "/" + m
    },
    isEditStatus: function(status,targetName){
      var statusName = this.getCpapStatus(status)
      return statusName == targetName
    },
    isOutPutProgress: function(code,targetValue) {
      var flg = false
      var target = this.progressList.find(val => val.code == code)
      if(target && target.name.indexOf(targetValue) != -1){
        flg = true
      }
      return flg
    },
    isOutPutKind: function(code,targetValue) {
      var flg = false
      var target = this.kindList.find(val => val.code == code)
      if(target && target.name.indexOf(targetValue) != -1){
        flg = true
      }
      return flg
    },
    gatDepartmentCode: async function() {
      // 診療科コードリスト取得
      var excuteApi = this.getCpapDepartmentCodeListPOST;
      var successCallBack = this.getCpapDepartmentCodeListPOSTSuccess;
      var errorCallBack = this.getCpapDepartmentCodeListPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapDepartmentCodeListPOST: function(client) {
      return client.apis.apiCommon.getCpapDepartmentCodeListPOST({
        body:{}
      });
    },
    getCpapDepartmentCodeListPOSTSuccess: function(result) {
      this.departmentMaster = result.obj
    },
    getCpapDepartmentCodeListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    gatCodeMasterList: async function() {
      // CPAP汎用コードマスタリストの取得
      var excuteApi = this.getCpapCodeMasterListPOST;
      var successCallBack = this.getCpapCodeMasterListPOSTSuccess;
      var errorCallBack = this.getCpapCodeMasterListPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapCodeMasterListPOST: function(client) {
      return client.apis.apiCommon.getCpapCodeMasterListPOST({
        body:[
          this.cpapCodeMaster.orderProcessType,
          this.cpapCodeMaster.rentalType,
          this.cpapCodeMaster.customerCategory,
          // 戦略施策(不要)
          // this.cpapCodeMaster.strategicMeasures,
          // 予備(不要)
          // this.cpapCodeMaster.reserve,
          this.cpapCodeMaster.deliveryTimeZone,
          this.cpapCodeMaster.cancellReason,
          this.cpapCodeMaster.billedCurrentMonth
        ]
      });
    },
    getCpapCodeMasterListPOSTSuccess: function(result) {
      this.orderProcessType = result.obj[this.cpapCodeMaster.orderProcessType]
      this.rentalType = result.obj[this.cpapCodeMaster.rentalType]
      this.customerCategory = result.obj[this.cpapCodeMaster.customerCategory]
      this.deliveryTimeZone = result.obj[this.cpapCodeMaster.deliveryTimeZone]
      this.cancelCodeMaster = result.obj[this.cpapCodeMaster.cancellReason]
      this.billedCurrentMonth = result.obj[this.cpapCodeMaster.billedCurrentMonth]
    },
    getCpapCodeMasterListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    setHospital: function(hospitalInfo){
      this.data.transferDestinationId = hospitalInfo.id
      this.data.transferDestinationCode = hospitalInfo.customerCode
      this.data.transferDestinationName = hospitalInfo.orgName
    },
    hospitalDecision: function(){
      // 転院先設定
      var excuteApi = this.setCpapTransferDestinationPOST;
      var successCallBack = this.setCpapTransferDestinationPOSTSuccess;
      var errorCallBack = this.setCpapTransferDestinationPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapTransferDestinationPOST: function(client) {
      return client.apis.externalCpap.setCpapTransferDestinationPOST({
        body:{
          receiptNumber:this.data.receiptNumber,
          transferDate:this.data.transferDate ? this.data.transferDate.replace(/-/g, "/") :"",
          transferDestinationId:this.data.transferDestinationId,
          transferDestinationCode:this.data.transferDestinationCode,
          transferDestinationName:this.data.transferDestinationName,
          transferMemo:this.data.transferMemo
        }
      });
    },
    setCpapTransferDestinationPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.$emit("back");
    },
    setCpapTransferDestinationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    isTransferDestination: function() {
      if(this.transferDestination && !this.data.transferDestinationName){
        return false
      }
      return true
    },
    addressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        if (this.data.returnSource == 1) {
          this.data.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.data.address1 = ""
          this.data.address2 = ""
        } else {
          this.data.deliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.data.deliveryHouseNumber = ""
          this.data.deliveryBuilding = ""
        }
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = ""
    },
    changedCheck: function(itemName,value) {
      // 一つ前の処方と値を比較し変更がある場合はtrueを返却
      if(this.data.comparisonDatas && this.data.comparisonDatas.length>0){
        let target = this.data.comparisonDatas.find(val => val.itemName == itemName)
        // console.log("alsoak",target);
        if(target){
          if(target.value != value){
            return true;
          }
        }
      }
      return false
    },
    changedPrescriptionCheck: function(displayName) {
      // 一つ前の処方と値を比較し変更がある場合はtrueを返却  
      if(this.data.comparisonPrescriptionItems && this.data.comparisonPrescriptionItems.length>0){
          let oldTarget = this.data.comparisonPrescriptionItems.find(val => val.displayName == displayName)
          let target = this.data.prescriptionItems.find(val => val.displayName == displayName)
          if(oldTarget && target){
            if(oldTarget.value != target.value){
              return true
            }
          }
      }
      return false
    },
    hardwareCheck: function() {
      // 機種変更時は、設定情報、加温加湿器、通信モジュール全ての項目にラベルが表示される
      if(this.data.comparisonDatas && this.data.comparisonDatas.length>0){
        let target = this.data.comparisonDatas.find(val => val.itemName == "model")
        if(target.value != this.data.model){
          return true
        }
      }
      return false
    },
    modulchangedCheck: function() {
      // モデム機種変更時は、通信モジュール全ての項目にラベルが表示される
      if(this.data.comparisonDatas && this.data.comparisonDatas.length>0){
        let target = this.data.comparisonDatas.find(val => val.itemName == "moduleSerial")
        if(target.value != this.data.moduleSerial){
          return true
        }
      }
      return false
    },
    addCheck: function(areaName) {
      if(this.data.comparisonPrescriptionItems && this.data.comparisonPrescriptionItems.length>0){
        // モデム追加、加湿器追加の場合それぞれの項目全てにラベルが表示される。
        if(areaName == "moistArea"){
          let oldTarget = this.data.comparisonPrescriptionItems.find(val => val.displayName == "加温加湿器")
          let target = this.data.prescriptionItems.find(val => val.displayName == "加温加湿器")
          if(oldTarget && target){
            if(oldTarget.value == 0 && target.value == 1){
              return true
            }
          }
        }else if(areaName == "moduleArea"){
          let oldTarget = this.data.comparisonPrescriptionItems.find(val => val.displayName == "通信モジュール")
          let target = this.data.prescriptionItems.find(val => val.displayName == "通信モジュール")
          if(oldTarget && target){
            if(oldTarget.value == 0 && target.value == 1){
              return true
            }
          }
        }
      }
      return false
    }
  },
  data() {
    // 処方再開(転院)判定
    var resume = false;
    if(this.$route.params["resume"] || this.isResume){
      resume = true;
    }
    // 預託在庫からの申込み判定
    var isInstrument = false;
    if(this.$route.params["instrument"]){
      isInstrument = this.$route.params["instrument"];
    }
    let models = this.getCpapMaster();
    var transferDestination = false
    if(this.data){
      transferDestination = this.data.transferDestinationName ? true : false
    }
    var kindList = this.getCpapKindList();
    var progressList = this.getCpapManagementStatusList();
    var branchOfficeMaster= this.getSalesOfficeMaster();
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = "";
    var userId = "";
    var isHospital = false;
    var isDealer = false;
    var isSalesOffice = false;
    var isHonsha = false;
    var isAdmin = false;
    if(userInfo){
      var roleId = userInfo.roleId;
      var userId = userInfo.id;
      var isHospital = roleId == role.role_hospital;
      var isDealer = roleId == role.role_dealer;
      var isSalesOffice = roleId == role.role_salesOffice;
      var isHonsha = roleId == role.role_headOffice;
      var isAdmin = roleId == role.role_admin;
    }
    var isMaster = true
    if(this.$props.isMasterAcquisition!=undefined){
      isMaster = this.$props.isMasterAcquisition
    }
    var isDeliveryInfoHidden = false
    if(this.$props.deliveryHidden!=undefined){
      isDeliveryInfoHidden = this.$props.deliveryHidden
    }
    var isRequest = false
    if(this.$props.requestFlg!=undefined){
      isRequest = this.$props.requestFlg
    }
    var officeCode = userInfo ? userInfo.salesOfficeCode : ""
    var directionsItemList = []
    if(this.$props.directionsItem && this.$props.directionsItem.length>0){
      directionsItemList = this.$props.directionsItem
    }
    var isViewer = false
    if(this.$props.viewerFlg!=undefined){
      isViewer = this.$props.viewerFlg
    }
    return {
      role: role,
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      extUserStatus: extUserStatus,
      models,
      cpapShippingMethodList:cpapShippingMethodList,
      cpapSenderMaster:cpapSenderMaster,
      cpapCodeMaster:[],
      progressList,
      kindList,
      departmentMaster:[],
      orderProcessType:[],
      rentalType:[],
      customerCategory:[],
      deliveryTimeZone:[],
      transferDestination,
      organizationModalActive: false,
      cancelCodeMaster:[],
      billedCurrentMonth:[],
      isMaster,
      cpapKindMap:cpapKindMap,
      officeCode,
      branchOfficeMaster,
      cpapDirectShippingList:cpapDirectShippingList,
      cpapLeaseUpList:cpapLeaseUpList,
      isDeliveryInfoHidden,
      isRequest,
      isInstrument,
      directionsItemList,
      resume,
      isViewer,
      searchTargetPostCode:"",
      searchTargetAddress: null,
      // 半角数字エラーメッセージ表示
      invalidPostcode: false,
      invalidPatientPostcode: false,
      invalidPhoneNumber: false,
      invalidPatientPhoneNumber: false,
      invalidPatientMobilePhoneNumber: false,
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
    };
  },
  components: {
    organizationSelectModal:OrganizationSelectModal
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.itemCodes && item.itemCodes.indexOf(val) != -1)
      if(target){
        return target.itemName
      }
      return ""
    },
    getSelectValueFilter: function(val, list){
      var target = list.find(item => item.key+"" == val+"")
      if(target){
        return target.value
      }
      return ""
    },
    getCalenderValueFilter: function(val){
      if(!val){
        return
      }
      return val.replace(/-/g,'/')
    },
    codeToValueFilter: function(val, list){
      var target = list.find(item => item.code+"" == val+"")
      if(target){
        return target.name
      }
      return ""
    },
    valueToTextFilter: function(val, list){
      var target = list.find(item => item.value+"" == val+"")
      if(target){
        return target.text
      }
      return ""
    },
    infectionFilter: function(val){
      switch(val){
        case "0":
          return "無し"
        case "1":
          return "MRSA"
        case "2":
          return "HCV"
        case "3":
          return "HBV"
        case "4":
          return "Wa"
        case "5":
          return "その他"
        default:
          return ""
      }
    }
  },
  mounted: async function() {
    // マスタ取得の必要が無い場合は回避（非ログイン時：申込内容確認ページ用）
    if(this.isMaster){
      // CPAP汎用コードマスタ取得
      this.cpapCodeMaster = await this.getCpapCodeMaster();
      if(!this.isRequest){
        // 診療科コード取得
        await this.gatDepartmentCode()
        // webHTコードマスタ
        await this.gatCodeMasterList()
      }
    }
    
    this.invalidPatientPostcode = isNaN(Number(this.data.patient.zip));
    this.invalidPatientMobilePhoneNumber = isNaN(Number(this.data.patient.mobilePhone));
    this.invalidPatientPhoneNumber = isNaN(Number(this.data.patient.phoneNumber));
    this.invalidPostcode = isNaN(Number(this.data.zip));
    this.invalidPhoneNumber = isNaN(Number(this.data.phoneNumber));
    if (this.data.kind == 3) {
      this.invalidPatientPostcode = isNaN(Number(this.data.deliveryPostcode));
      this.invalidPatientMobilePhoneNumber = isNaN(Number(this.data.deliveryPhoneNumber));
    }
  },
  watch: {
    "data.zip"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
    "data.patient.zip"(newValue) {
      this.invalidPatientPostcode = isNaN(Number(newValue));
    },
    "data.phoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
    "data.patient.phoneNumber"(newValue) {
      this.invalidPatientPhoneNumber = isNaN(Number(newValue));
    },
    "data.patient.mobilePhone"(newValue) {
      this.invalidPatientMobilePhoneNumber = isNaN(Number(newValue));
    },
    "data.deliveryPostcode"(newValue) {
      this.invalidPatientPostcode = isNaN(Number(newValue));
    },
    "data.deliveryPhoneNumber"(newValue) {
      this.invalidPatientMobilePhoneNumber = isNaN(Number(newValue));
    }
  },
};
</script>
<style lang="scss" scoped>
#item-contens table.settings tr th {
  width: 300px;
}
#editMark{
  width:50px;
  vertical-align: middle;
}
.change::after {
  position: static;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/common/CpapRequestDetail.vue